import { Button } from '../../core/index.js'
import { RefreshCw } from 'lucide-react'
import type { ReactNode } from 'react'

export const INPUT_CLASS = 'w-full border border-marine/25 px-3 py-2 text-sm text-ink focus:outline-none focus:border-marine'

export function Labeled({ label, hint, htmlFor, children }: { label: string; hint?: string; htmlFor: string; children: ReactNode }) {
  return (
    <div>
      <label className="block text-xs font-bold text-ink-mid mb-1" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint && <p className="text-[11px] text-ink-mid mt-1">{hint}</p>}
    </div>
  )
}

export function Section({ step, title, children }: { step: string; title: string; children: ReactNode }) {
  return (
    <section className="bg-white border border-marine/15 p-6 mb-5">
      <div className="text-[9px] font-bold uppercase tracking-[2.5px] text-coral">{step}</div>
      <h2 className="text-base font-black text-ink mb-4">{title}</h2>
      {children}
    </section>
  )
}

export function ErrorNote({ message, onRetry, retrying = false }: { message: string; onRetry?: () => void; retrying?: boolean }) {
  return (
    <div role="alert" className="flex flex-wrap items-center gap-x-3 gap-y-2 border border-coral bg-coral-lt px-4 py-3 text-xs text-ink">
      <span>{message}</span>
      {onRetry && (
        <Button icon={RefreshCw} variant="secondary" size="sm" disabled={retrying} onClick={onRetry}>
          {retrying ? 'Trying…' : 'Try again'}
        </Button>
      )}
    </div>
  )
}

export function SuccessNote({ children }: { children: ReactNode }) {
  return <div className="border border-green bg-green-lt px-4 py-3 text-xs text-ink">{children}</div>
}

/** What to show a person when a call fails: the API's own message where there is one. */
export function describeError(error: unknown, fallback: string): string {
  return error instanceof Error && error.message !== '' ? error.message : fallback
}
